import React from "react";
import "./Home2.css";
import logoRoad from "./assets/images/logo.png"; // путь относительно Home2.js
import BannerRotator from "./BannerRotator"; // импорт баннера
import Navbar2 from "./Navbar2";
export default function Home2() {
    return (
        <div className="home2-container">
            {/* Первая навигация */}
            <Navbar2 /> {/* вставили навигацию */}


            <header className="hero-section">
                <BannerRotator />
            </header>

            <section className="advantages-section">
                <h2>Почему выбирают нас</h2>
                <div className="advantages-list">
                    <div className="advantage-item">
                        <img src="https://media.istockphoto.com/id/953520974/ru/%D0%B2%D0%B5%D0%BA%D1%82%D0%BE%D1%80%D0%BD%D0%B0%D1%8F/%D0%B7%D0%BD%D0%B0%D0%BA-%D1%82%D0%B8%D0%BA-%D1%83%D1%82%D0%B2%D0%B5%D1%80%D0%B6%D0%B4%D0%B5%D0%BD-%D0%B7%D0%BD%D0%B0%D1%87%D0%BE%D0%BA-%D0%B2%D0%B5%D0%BA%D1%82%D0%BE%D1%80-%D1%89%D0%B8%D1%82%D0%B0-%D0%BD%D0%B0-%D0%B1%D0%B5%D0%BB%D0%BE%D0%BC-%D1%84%D0%BE%D0%BD%D0%B5.jpg?s=612x612&w=0&k=20&c=3E7FpcWaTRQzeOFzIl2e7lM0Vf0V4C3BgtjB2fYl2To=" alt="Преимущество 1" />
                        <h3>Надежность</h3>
                        <p>Мы гарантируем финансовую защиту и поддержку.</p>
                    </div>
                    <div className="advantage-item">
                        <img src="https://www.scat.kz/upload/structure_2/2/0/7/structure_207/structure_property_image_90.svg" alt="Преимущество 2" />
                        <h3>Простота оформления</h3>
                        <p>Все процессы максимально автоматизированы и понятны.</p>
                    </div>
                    <div className="advantage-item">
                        <img src="https://sberbankins.ru/upload/iblock/99f/3ezufbfkhpvqlym9uy1u9l716hcgxg5i/torg_kredit_3.png" alt="Преимущество 3" />
                        <h3>Выгодные тарифы</h3>
                        <p>Наши цены оптимальны для разных категорий клиентов.</p>
                    </div>
                </div>
            </section>

            <footer className="footer">
                <p>© 2025 АвтоСтраховка. Все права защищены.</p>
                <div>🏢 Адрес: г. Ташкент, ул. *******, 123</div>
                <div>📞 Связь: @telegrambot | +998900000000</div>            </footer>
        </div>
    );
}
